var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignupStep6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Steeper/06 Payment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 19.9998 0 19.9998 16.1018 0 16.1018"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Steeper/06-Payment",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(-0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9988,3.9958 L1.9988,2.9988 C1.9988,2.4468 2.4468,1.9988 2.9978,1.9988 L17.0018,1.9988 C17.5528,1.9988 18.0008,2.4468 18.0008,2.9988 L18.0008,3.9958 L1.9988,3.9958 Z M17.0018,-0.0002 L2.9978,-0.0002 C1.3448,-0.0002 -0.0002,1.3448 -0.0002,2.9988 L-0.0002,7.6348 C-0.0002,8.1878 0.4468,8.6348 0.9998,8.6348 C1.5518,8.6348 1.9988,8.1878 1.9988,7.6348 L1.9988,6.4948 L18.0008,6.4948 L18.0008,13.1038 C18.0008,13.6548 17.5528,14.1028 17.0018,14.1028 L2.9978,14.1028 C2.4468,14.1028 1.9988,13.6548 1.9988,13.1038 L1.9988,11.6358 C1.9988,11.0838 1.5518,10.6368 0.9998,10.6368 C0.4468,10.6368 -0.0002,11.0838 -0.0002,11.6358 L-0.0002,13.1038 C-0.0002,14.7568 1.3448,16.1018 2.9978,16.1018 L17.0018,16.1018 C18.6548,16.1018 19.9998,14.7568 19.9998,13.1038 L19.9998,2.9988 C19.9998,1.3448 18.6548,-0.0002 17.0018,-0.0002 L17.0018,-0.0002 Z",
    id: "Fill-1",
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupStep6);
export default __webpack_public_path__ + "static/media/signup-step-6.1c152669d26b49b39d355950d3f636ce.svg";
export { ForwardRef as ReactComponent };